export const STATUS_PENDING = "pending";
export const STATUS_RESOLVED = "resolved";
export const STATUS_REJECTED = "rejected";
